var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-scrollbar',{staticClass:"default-scrollbar",attrs:{"wrap-class":"default-scrollbar__wrap","view-class":"default-scrollbar__view"}},[_c('div',{ref:"main-content",staticClass:"main-content content layout-compact"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{ref:"childRouter"})],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }